import React from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

interface Props {
    className?: string;
    title?: string;
    size: string;
    children?: React.ReactNode
}

const SectionTitle = ({
    className,
    title,
    size,
    children
}: Props): JSX.Element => (
    title === '相關文章內容' ? (
        <h3 className={classnames({ [styles.lg]: size === 'lg', [styles.md]: size === 'md' }, className, styles.title)}>
            {title}
            {children}
        </h3>
    ) : (
        <h2 className={classnames({ [styles.lg]: size === 'lg', [styles.md]: size === 'md' }, className, styles.title)}>
            {title}
            {children}
        </h2>
    )

);

SectionTitle.defaultProps = {
    className: '',
    title: '',
    children: null
};

export default SectionTitle;
